/**
 * ============================================================================
 * ConfidenceBadge — Phase 6c frontend (CCIE).
 * Owner: Claude 3 (Frontend & UX).
 * Purpose: a small badge displayed beside every impact-set row. HIGH = filled
 *          green; MEDIUM = outlined amber; LOW = outlined gray. Colour is
 *          paired with a textual label so it is not the sole signal (WCAG
 *          1.4.1).
 * ============================================================================ */

import { useTranslation } from 'react-i18next';
import styles from './ImpactSetReview.module.css';
import type { Confidence } from './useImpactSetQuery';

export interface ConfidenceBadgeProps {
  confidence: Confidence;
}

const CONFIDENCE_CLASS: Record<Confidence, string> = {
  HIGH: styles.confHigh,
  MEDIUM: styles.confMedium,
  LOW: styles.confLow,
};

export function ConfidenceBadge({ confidence }: ConfidenceBadgeProps) {
  const { t } = useTranslation();

  const label = t(`changeControl.impactSet.confidence.${confidence}`, {
    defaultValue: confidence,
  });

  return (
    <span
      className={`${styles.confidenceBadge} ${CONFIDENCE_CLASS[confidence]}`}
      aria-label={t('changeControl.impactSet.confidenceAria', {
        defaultValue: 'Confidence: {{value}}',
        value: label,
      })}
    >
      {label}
    </span>
  );
}
